import React, { useEffect, useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useStateValue } from '../../state';
import SiteContactArtifact from './SiteArtifact';
import SiteContactForm from './SiteForm';

const duration = 500

const SiteList = () => {
  const [{ modified, formPrefix, sites }] = useStateValue();
  const nodeRefsRef = useRef(new Map<string, React.RefObject<HTMLLIElement>>())
  const getNodeRef = (key: string) => {
    if (!nodeRefsRef.current.has(key)) {
      nodeRefsRef.current.set(key, React.createRef<HTMLLIElement>())
    }
    return nodeRefsRef.current.get(key)!
  }

  useEffect(
    () => {
      if (modified) {
        //@ts-ignore
        window.modalApi ? window.modalApi.setConfirmClose(true) : null
      }
    },
    [modified]
  )

  return (
    <ul className="card-list dash__card mb-4">
      {sites.length === 0 && (
        <li className="s2-card-tx contact-card list-item bg-light text-center">
          No Sites Selected
        </li>
      )}
      <TransitionGroup component={null}>{
        sites.map(
          (site, idx) => {
            const rowPrefix = `${formPrefix}[${idx}]`
            if (site.deleted) {
              const nodeRef = getNodeRef(site.site.id + 'artifact')
              return (
                <CSSTransition key={site.site.id + 'artifact'} nodeRef={nodeRef} timeout={duration} classNames="artifact">{
                  () => (
                    <li className="s2-card-tx contact-card list-item bg-light" ref={nodeRef}>
                      <SiteContactArtifact
                        site={site}
                        rowPrefix={rowPrefix}
                      />
                    </li>
                  )
                }</CSSTransition>
              )
            } else {
              const nodeRef = getNodeRef(site.site.id + 'form')
              return (
                <CSSTransition key={site.site.id + 'form'} nodeRef={nodeRef} timeout={duration} classNames={site.site.id ? 'shrink' : 'slide'}>
                  <li className="s2-card-tx contact-card list-item" ref={nodeRef}>
                    <SiteContactForm
                      site={site}
                      rowPrefix={rowPrefix}
                    />
                  </li>
                </CSSTransition>
              )
            }
          }
        )
      }</TransitionGroup>
    </ul>
  )
}
export default SiteList
